module.exports = __webpack_public_path__ + "ec795f4197119bf253a40a821164f347.png";